// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

// local imports
import { styles } from './faq.style';

function FAQ(props: WithStyles<typeof styles>) {
    const { classes } = props;

    const Question = ({ subtitle, body }: { subtitle: string; body: Array<React.ReactNode> }) => (
        <Box className={classes.section}>
            <p className={classes.subtitle}>{subtitle}</p>
            {body.map((item, idx) => (
                <p key={idx} className={classes.text}>
                    {item} <br />
                </p>
            ))}
            <br />
            <br />
            <hr />
        </Box>
    );

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <Box className={classes.titleContainer}>
                    <p className={classes.title}>PREGUNTAS</p>
                    <p id="bot" className={classes.title}>
                        FRECUENTES
                    </p>
                </Box>
                <Question
                    subtitle="¿Qué es Cuenca?"
                    body={[
                        `Somos una Fintech que revoluciona las finanzas 
                        personales en México. Creamos un servicio 
                        financiero que nosotros usamos pensando en ti, 
                        desde tu teléfono móvil tienes acceso a tu dinero 
                        de forma segura e inmediata 24/7, puedes enviar y 
                        recibir fondos con múltiples opciones. Puedes abrir 
                        una cuenta en menos de 5 minutos, realizar compras 
                        en línea, pagar la renta, luz y todos tus gastos. 
                        ¡Cuenca es la única cuenta que necesitas! `,
                    ]}
                />
                <Question
                    subtitle="¿Quién puede abrir una cuenta Cuenca?"
                    body={[
                        `¡Cuenca es para ti, es para todxs! En dos 
                    sencillos pasos la puedes obtener: primero descarga 
                    la app, después regístrate.`,
                    ]}
                />
                <Question
                    subtitle="¿Qué necesito para abrir una cuenta?"
                    body={[
                        `Un teléfono inteligente e identificación oficial: 
                        INE, Pasaporte Mexicano o Tarjeta de Residencia. Si necesitas una cuenta y no tienes 
                        identificación oficial pero tienes 18 años, solo 
                        necesitas tu CURP. Regístrate en menos de 5 minutos.`,
                    ]}
                />
                <Question
                    subtitle="¿Qué costo tiene abrir una cuenta?"
                    body={[`No tienen ningún costo abrir una cuenta con Cuenca.`]}
                />
                <Question
                    subtitle="¿Hay comisiones en Cuenca?"
                    body={[
                        `En Cuenca no cobramos comisiones por transferencias 
                        entre cuentas Cuenca o por Whastapp. Tienes 15 
                        transferencias gratis cada mes, a partir de la número 16, 
                        tienen un costo de $10 MXN cada una y el costo mensual 
                        por manejo de cuenta es de $50 MXN (IVA incluido). `,
                    ]}
                />
                <Question
                    subtitle="¿Qué son los Apartados de Cuenca?"
                    body={[
                        `Guarda tus fondos y logra tus metas con Apartados. 
                        El dinero en tus apartados está separado del saldo 
                        principal y no generará ningún rendimiento. Podrás 
                        tener acceso al dinero en tus apartados transfiriendolo 
                        de vuelta a tu saldo principal. No tiene un costo 
                        adicional, úsalo desde tu app. `,
                    ]}
                />
                <Question
                    subtitle="¿Se pueden realizar transferencias a otras cuentas 
                    que no son de Cuenca?"
                    body={[
                        `Se pueden realizar hasta 15 transferencias gratis a cuentas 
                        que no son Cuenca. Además se pueden realizar transferencias 
                        vía Whatsapp.`,
                    ]}
                />
                <Question
                    subtitle="¿Cuenca es una empresa mexicana?"
                    body={[
                        `Está constituida de acuerdo con la legislación mexicana, 
                        en específico con la Ley Fintech, sin embargo, tiene inversión 
                        extranjera.`,
                    ]}
                />
                <Question
                    subtitle="¿El área de soporte está disponible 24/7?"
                    body={[
                        `Cuenca tiene un área de soporte que se caracteriza 
                        por ser humana y empática. Luisa, nuestra agente de 
                        soporte, es muy amable y siempre busca las soluciones 
                        más eficaces y eficientes. Funciona a través de Whatsapp 
                        para proteger la información de los usuarios y la 
                        encriptación de los mensajes. Los horarios de atención 
                        son de lunes a viernes de 10:00 a 22:00 horas y sábados y 
                        domingos de 11:00 a 18:00 horas.`,
                    ]}
                />
                <Question
                    subtitle="¿Cuenca tiene sucursales?"
                    body={[
                        `La única sucursal que necesitas la tienes en la palma 
                        de tu mano en tu aplicación. No contamos con sucursales 
                        pero nuestro servicio está disponible las 24/7.`,
                    ]}
                />
                <Question
                    subtitle="¿Cómo se puede cancelar mi cuenta Cuenca?"
                    body={[
                        `Sentimos mucho escuchar que quieres cancelar tu cuenta :( Si deseas 
                        iniciar el proceso, te pedimos que nos contactes mediante el canal 
                        oficial de Whatsapp donde por motivos de seguridad y para verificar 
                        tu identidad el equipo de soporte te solicitará enviar un video selfie 
                        sosteniendo tu identificación/pasaporte mencionando tu nombre completo, 
                        la fecha del día y solicitud o puedes realizar la cancelación desde tu 
                        perfil en la app, seleccionado la opción “Cancelar cuenta”.`,
                        `Recuerda que debes haber cubierto las comisiones por manejo de cuenta 
                        hasta ese momento y tener tu saldo en $0.00.`,
                    ]}
                />
                <Question
                    subtitle="¿Puedo solicitar estados de cuenta?"
                    body={[
                        `Sí, para poder realizar la solicitud de un estado de cuenta 
                        es necesario cumplir con los siguientes requisitos: contar 
                        con un RFC dado de alta ante el SAT, constancia de situación 
                        fiscal y que coincidan con los datos registrados en tu app. 
                        Puedes generar los estados de cuenta directamente en tu app, 
                        en la sección “Estados de cuenta”`,
                    ]}
                />
                <Question
                    subtitle="¿Cuáles son los límites de mi cuenta?"
                    body={[
                        <>
                            {`En Cuenca, los límites de operación disponibles dependen 
                            del nivel de tu cuenta. De conformidad con la normativa 
                            aplicable, las Cuentas de Fondos de Pago Electrónico 
                            se clasifican en niveles 1, 2 y 3.`}
                        </>,
                        <div style={{ paddingLeft: '20px' }}>
                            {`I. En las Cuentas Nivel 1 la suma de los abonos, durante
                             el transcurso de un mes calendario, no podrá exceder 
                             el equivalente en moneda nacional a 750 
                             (setecientas cincuenta) UDIS. En ningún momento, la suma 
                             de los saldos en dichas Cuentas podrá exceder al 
                             equivalente en moneda nacional a 1,000 (mil) UDIS.`}
                            <br />
                            {`La información personal y/o documentación que se requerirá 
                            del Cliente para este nivel será la contenida en el 
                            formulario de registro.`}
                        </div>,
                        <div style={{ paddingLeft: '20px' }}>
                            {`II. En las Cuentas Nivel 2 la suma de los abonos, durante 
                            el transcurso de un mes calendario, no podrá exceder el 
                            equivalente en moneda nacional a 3,000 (tres mil) UDIS.`}
                            <br />
                            {`La suma de los saldos en dichas Cuentas no tendrá ningún 
                            límite. La información personal y/o documentación que se 
                            requerirá del Cliente para este nivel será:`}
                            <br />
                            <div style={{ paddingLeft: '20px' }}>
                                {`a) La contenida en el formulario de registro.`}
                                <br />
                                {`b) Identificación Oficial, pudiendo ser esta: 
                                Identificación emitida por el Instituto Nacional Electoral 
                                (INE), pasaporte o tarjeta de residencia.`}
                            </div>
                        </div>,
                        <div style={{ paddingLeft: '20px' }}>
                            {`III. En las Cuentas Nivel 3 la suma de los abonos y 
                            saldos realizados a la Cuenta del Cliente no tendrá límite. 
                            La información personal y/o documentación que se requerirá 
                            del Cliente para este nivel será:`}
                            <br />
                            <div style={{ paddingLeft: '20px' }}>
                                {`a) La contenida en el formulario de registro.`}
                                <br />
                                {`b) Identificación Oficial, pudiendo ser esta: la 
                                identificación emitida por el Instituto Nacional Electoral 
                                (INE), pasaporte o tarjeta de residencia.`}
                                <br />
                                {`c) Comprobante de domicilio.`}
                                <br />
                                {`d) Prueba de vida, la cual consistirá en la grabación de 
                                un video donde figure el Cliente a fin de poder verificar 
                                su identidad.`}
                            </div>
                        </div>,
                    ]}
                />
                <Question
                    subtitle="¿Cómo se calculan los límites en UDIS?"
                    body={[
                        <>
                            {`Para el cálculo en UDIS de los límites señalados, 
                            Cuenca tomará el valor de dicha unidad de cuenta del 
                            último día del mes calendario inmediato anterior al mes 
                            de que se trate.`}
                        </>,
                    ]}
                />
                <Question
                    subtitle="¿Puedo recibir transferencias desde cuentas en el extranjero?"
                    body={[
                        `Por el momento no contamos con IBAN/SWIFT para transferencias 
                        internacionales directas.`,
                    ]}
                />
                <Question
                    subtitle="¿Cómo puedo recibir transferencias desde otra institución?"
                    body={[
                        `Para recibir transferencias desde otra institución a tu cuenta 
                    Cuenca solo debes vincularla desde: “Cartera“ > Asociar cuenta 
                    bancaria > e ingresar tu CLABE interbancaria Cuenca que encuentras 
                    en la sección *“Recibir“* de tu app.`,
                    ]}
                />
                <Question
                    subtitle="¿Cómo puedo enviar una transferencia a otra institución?"
                    body={[
                        `Para transferir ingresa a tu app a Enviar > Selecciona el monto 
                    > Elige a tu contacto o ingresa la CLABE, ¡y listo!`,

                        `Recuerda que también puedes transferir vía Whatsapp, para realizar 
                    estas transferencias los números telefónicos de quien envía y quien 
                    recibe deben estar asociados a Whatsapp. Si el destinatario tiene una 
                    cuenta Cuenca, recibirá la transferencia de inmediato; en caso de no 
                    tener Cuenca, le enviaremos un link donde deberá ingresar los datos 
                    de su institución financiera para recibir los fondos.`,
                    ]}
                />
                <Question
                    subtitle="¿Cómo puedo pagar servicios desde mi app? /¿Qué servicios 
                    puedo pagar?"
                    body={[
                        `Consulta los más de 18 mil establecimientos disponibles en 
                    tu app “Hacer Pagos”. Se pueden cubrir servicios de electricidad, 
                    agua, televisión por cable, tarjetas de crédito, gas, y plan móvil, 
                    entre otros.`,
                    ]}
                />
                <Question
                    subtitle="¿Puedo abrir una cuenta empresarial?"
                    body={[
                        `Por el momento no contamos con cuentas para personas morales, 
                    estamos dedicados en ofrecer los mejores productos para personas 
                    físicas únicamente.`,
                    ]}
                />
                <Question
                    subtitle="¿Qué tratamiento se le da a mis datos personales? / 
                    ¿Quién tiene acceso a mis datos personales? / ¿Cómo están 
                    protegidos mis datos personales?"
                    body={[
                        `Cuenca es la responsable del tratamiento de los datos 
                    personales que se recolectan a través de su plataforma, 
                    página de internet y medios electrónicos de contacto y/o 
                    soporte al cliente.`,

                        `Los datos personales que se recaban por Cuenca serán 
                    utilizados con la finalidad de proporcionar, mantener y 
                    mejorar nuestros servicios financieros; y podrá realizar 
                    transferencias de datos únicamente con las empresas integrantes 
                    de su mismo grupo empresarial, con los terceros y autoridades 
                    referidos en el Aviso de Privacidad únicamente a fin de dar 
                    cumplimiento a la regulación aplicable a las Instituciones de 
                    Fondos de Pago Electrónico.`,

                        `Cuenca no venderá, cederá o transferirá los datos personales 
                    del cliente o usuario a terceros ajenos a la empresa, 
                    sus filiales, subsidiarias y partes relacionadas, o terceros 
                    distintos a los anteriormente mencionados sin su consentimiento 
                    previo.`,

                        `Si desea conocer nuestro Aviso de Privacidad integral, lo 
                    podrá consultar en la siguiente dirección electrónica o 
                    directamente en nuestra aplicación móvil: 
                    https://cuenca.com/aviso-privacidad. `,
                    ]}
                />
                <Question
                    subtitle="¿Mis recursos están garantizados?"
                    body={[
                        `Cuenca es una institución financiera privada que opera 
                        conforme a la regulación aplicable. Por ello, el Gobierno 
                        Federal y las Entidades de la Administración Pública 
                        Paraestatal no garantizan ni asumen responsabilidad 
                        sobre los recursos utilizados en las operaciones 
                        realizadas a través de Cuenca, ni sobre las obligaciones 
                        que pudieran derivarse entre Cuenca y sus usuarios o 
                        frente a terceros.`,
                    ]}
                />
                <Question
                    subtitle="¿Por qué se cierra mi sesión automáticamente?"
                    body={[
                        <>
                            Por tu seguridad, las sesiones de tu cuenta se cierran de forma automática después de un
                            periodo de inactividad de <strong>5 minutos</strong> en tu dispositivo móvil.
                        </>,
                        `El acceso a tu cuenta de Cuenca solo está disponible 
                        a través de la aplicación móvil, la página de internet 
                        solo es para fines informativos.`,
                    ]}
                />
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(FAQ);
